import { type ChangeHandler } from 'react-hook-form';

/**
 * Adapts vaporwave components to be used with react-hook-form forms
 * @param {object} p return value of a react-hook-form 'register' call
 * @param {ChangeHandler} p.onChange onchange event handler provided by react-hook form
 * @returns {object} result of register call, with onChange handler renamed to onChangeHandler
 */
export function fixupEvents(p: { onChange: ChangeHandler }) {
    const { onChange, ...rest } = p;
    return { onChangeHandler: onChange, ...rest };
}
